import IntegrationBase from 'eflex/models/integration-base';

export default class IntegrationInbox extends IntegrationBase {}
